import React, { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";

import ContactPopup from "./components/ContactPopup";
import Home from "./pages/Home";
import StudyAbroadPage from "./pages/StudyAbroad/StudyAbroad";
import Navbar from "./components/Navbar";
import GalleryPage from "./pages/Gallery";
import CounsellingPage from "./pages/Counselling";
import AboutPage from "./pages/About";
import Footer from "./components/footer";
import ContactUsForm from "./components/ContactForm";
import CountryOverview from "./pages/CountryOverview";
import ScrollToTop from "./components/ScrollToTop";
import Admin from "./pages/Admin";
import AdminLogin from "./pages/AdminLogin";
import ContactPage from "./pages/ContactUs";
import Login from "./pages/auth/Login";
import SignUp from "./pages/auth/Signup";
import ForgotPassword from "./pages/auth/ForgotPassword";
import ResetPassword from "./pages/auth/ResetPassword";
import Blog from "./pages/Blog";
import UserActivate from "./pages/auth/UserActivate";
import EnglishProficiency from "./components/EnglishProficiency/EnglishProficiency";
import IELTS from "./pages/IELTS";
import PrivacyPolicy from "./pages/legal/PrivacyPolicy";
import VisaPage from "./pages/Visa";
import EventDetailPage from "./pages/Event/EventDetails";
import EventsPage from "./pages/Event/Events";
import "./config/firebaseconfig";
import SocialFloatingIcons from "./components/Home/SocialFloatingIcons";
import CountryOverview2 from "./pages/CountryOverview/CountryOverview2";
import TestPrepPage from "./pages/TestPrepPage";
import CELPIPPage from "./pages/CELPIP";
import PTEPage from "./pages/PTE";
import TOEFLPage from "./pages/TOEFL";
import Duolingo from "./pages/Duolingo";
import SATPage from "./pages/SAT";
import GREPage from "./pages/GRE";
import GMATPage from "./pages/GMAT";
import EligibilityFlow from "./components/Eligibility/EligibilityFlow";
import UserProfile from "./pages/User/UserProfile";
import UniversitiesPage from "./pages/UniversitiesPage";

function AppContent() {
  const location = useLocation();
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    setShowPopup(true); // Show popup on every route change
  }, [location]);

  return (
    <>
      <ScrollToTop />
      <Navbar />

      {showPopup &&
        location.pathname !== "/admin" &&
        !location.pathname.includes("/profile") &&
        !location.pathname.includes("/login") &&
        !location.pathname.includes("/signup") &&
        !location.pathname.includes("/forgot-password") &&
        !location.pathname.includes("/reset-password") &&
        !location.pathname.includes("/activate-user") && 
        !location.pathname.includes("/events") && 
        !location.pathname.includes("/event-details") && (
          <ContactPopup onClose={() => setShowPopup(false)} />
        )}

      <Routes>
        {/* Auth */}
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<SignUp />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/reset-password/:token" element={<ResetPassword />} />
        <Route path="/activate-user/:token" element={<UserActivate />} />

        {/* User */}
        <Route path="/profile/:id" element={<UserProfile />} />

        {/* General */}
        <Route path="/" element={<Home />} />
        <Route path="/gallery" element={<GalleryPage />} />
        <Route path="/blog/:blogId" element={<Blog />} />
        <Route path="/counselling" element={<CounsellingPage />} />
        <Route path="/study-abroad" element={<StudyAbroadPage />} />
        <Route path="/About" element={<AboutPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/english-proficiency" element={<EnglishProficiency />} />
        <Route path="/ielts" element={<IELTS />} />
        <Route path="/celpip" element={<CELPIPPage />} />
        <Route path="/pte" element={<PTEPage />} />
        <Route path="/toefl" element={<TOEFLPage />} />
        <Route path="/duolingo" element={<Duolingo />} />
        <Route path="/sat" element={<SATPage />} />
        <Route path="/gre" element={<GREPage />} />
        <Route path="/visa" element={<VisaPage />} />
        <Route path="/gmat" element={<GMATPage />} />
        <Route path="/test-prep" element={<TestPrepPage />} />
        <Route path="/events" element={<EventsPage />} />
        <Route path="/eligibility" element={<EligibilityFlow />} />

        <Route path="/event-details/:id" element={<EventDetailPage />} />

        <Route path="/universities" element={<UniversitiesPage />} />

        {/* Contact form */}
        <Route path="/contact-us" element={<ContactUsForm />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/admin-login" element={<AdminLogin />} />

        {/* Country Pages */}
        <Route
          path="/country-overview/germany"
          element={<CountryOverview2 country={"germany"} />}
        />
        <Route
          path="/country-overview/usa"
          element={<CountryOverview2 country={"usa"} />}
        />
        <Route
          path="/country-overview/canada"
          element={<CountryOverview2 country={"canada"} />}
        />
        <Route
          path="/country-overview/europe"
          element={<CountryOverview2 country={"europe"} />}
        />
        <Route
          path="/country-overview/australia"
          element={<CountryOverview2 country={"australia"} />}
        />
        <Route
          path="/country-overview/newzealand"
          element={<CountryOverview2 country={"newzealand"} />}
        />
        <Route
          path="/country-overview/*"
          element={<CountryOverview2 country={"usa"} />}
        />

        {/* Legal */}
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      </Routes>
      {location.pathname !== "/admin" && <SocialFloatingIcons />}
      <FooterWrapper />
    </>
  );
}

function FooterWrapper() {
  const location = useLocation();
  if (location.pathname.startsWith("/admin")) return null;
  return <Footer />;
}

// Wrap AppContent with Router to allow useLocation inside
export default function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}
